import { productService } from './product.service'
import { nameUrlPair } from '../interfaces/definitions/nameUrlPair-interface'

export interface ImageData {
  userId: string
  url: string
  type?: 'photo' | 'video'
}
// All URLs resolve concurrently — one slow item no longer delays the rest
// behind it, and Promise.all keeps the original order.
const fetchNameUrls = async (imgNames: ImageData[]): Promise<nameUrlPair[]> => {
  return await Promise.all(
    imgNames.map(async (name): Promise<nameUrlPair> => {
      try {
        const fetchedUrl = await productService.getProductUrl(`public/${name.url}`)
        return { alt: name.url, src: fetchedUrl, type: name?.type }
      } catch (error: any) {
        throw new Error(`Error fetching URL for ${name.url}: ${error as string}`)
      }
    })
  )
}

export default fetchNameUrls
